/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [""];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/themes/default/css/dashboard.less.shim.ngstyle.js.pre-build-optimizer.js